import React from 'react'
import { changeAliasAction } from '../actions/Actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChangeAliasForm from '../components/forms/ChangeAliasForm'
import { Message } from '../locale/Message'

class MyCompanies extends React.Component {

  render() {
    const { customers, lang, changeAlias } = this.props;
    return (
      <div className="profile-wrapper container-fluid">
        <div className="row no-gutters justify-content-center">
          <div className=" profile col-xs-12 col-sm-8 col-md-7 .col-lg-7">
            <section className="profile-form row no-gutters bg-white justify-content-md-center">
              <div className="col-md-10 col-lg-8 text-center mb-5 px-4 px-md-0">
                <span className="t3 t-light">{Message.companiesInfo[lang]}</span>
              </div>
              <div className="col-md-8 col-lg-8 px-4 px-md-0">
                {
                  customers.map((customer, index) =>
                    <ChangeAliasForm
                      changeAlias={changeAlias}
                      customer={customer}
                      index={index}
                      key={index}
                      lang={lang}
                    />)
                }
              </div>
            </section>
          </div>
        </div>
      </div>
    )
  }

}

export default connect(
  state => ({
    customers: state.userInfo.assignCustomers,
    lang: state.lang
  }),
  dispatch => ({
    changeAlias: bindActionCreators(changeAliasAction, dispatch)
  })
)(MyCompanies)